<template>
  <div class="login bg-gradient-ex bg-london">
    <mdb-container>
      <mdb-row class="flex-center" style="min-height: 100vh">
        <mdb-col md="8" xl="4" class="text-center">
          <div class="start-header">
            <img src="../assets/Exsellance_Logo_Transparent_1.png" width="140px" />
          </div>
          <mdb-card class="p-3">
            <mdb-card-body>
              <mdb-card-title class="mb-3 text-center">
                <h1>Log In</h1>
              </mdb-card-title>
              <mdb-card-text>
                <div>{{validationMessage}}</div>
                <mdb-input v-model="email" label="Your email" type="email" class="mb-5" />
                <mdb-input v-model="password" label="Your password" type="password" />
                <span class="input--help">
                  <router-link to="/password-reset" href>Forgot password?</router-link>
                </span>
              </mdb-card-text>
              <mdb-card-footer class="text-center mt-3">
                <mdb-btn @click="login" color="primary">Login</mdb-btn>
              </mdb-card-footer>
            </mdb-card-body>
          </mdb-card>
          <div class="start-footer">
            <div class="start-footer-top">
              Don’t have an account?
              <router-link to="/register">
                <mdb-btn>Sign Up</mdb-btn>
              </router-link>
            </div>
            <div class="start-footer-bottom">
              <!--               <router-link v-if="false" to="/about">
                <span>About Exsellance</span>
              </router-link>
              <router-link v-if="false" to="/help">
                <span>Help</span>
              </router-link>-->
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbInput
} from "mdbvue";

import firebase from "firebase";
import { store } from "../store";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      validationMessage: ""
    };
  },
  methods: {
    mthSetIamthebossInStore(email) {
      let that = this;

      //console.log("mthSetIamthebossInStore called with parameter " + email);

      const docref = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(email);

      docref.get().then(snap => {
        if (!snap.exists) {
        } else {
          // console.log("snap data team: ");
          // console.log(snap.data());
          // console.log(snap.data().team);
          // console.log(snap.data().team.length);

          if (
            snap.exists &&
            snap.data() &&
            snap.data().team &&
            snap.data().team.length > 0
          ) {
            //console.log("i am the boss");

            that.$store.commit("setIamtheboss", true);
          } else {
            that.$store.commit("setIamtheboss", null);
          }
        }
      });
    },
    mthIncrementReturningUser() {
      //console.log("incrementing returning ");
      let dt = new Date();
      let y = dt.getFullYear().toString();
      let m = (dt.getMonth() + 1).toString();

      //console.log("callin");

      const docref = firebase
        .firestore()
        .collection("statsReturningUsers")
        .doc(y + "-" + m);

      //exists?
      docref.get().then(snap => {
        if (!snap.exists) {
          const docref = firebase
            .firestore()
            .collection("statsReturningUsers")
            .doc(y + "-" + m)
            .set({ counter: 1 });
        } else {
          const increment = firebase.firestore.FieldValue.increment(1);
          docref.update({ counter: increment });
        }
      });
    },
    resetPassword: function() {
      this.$router.replace("resetpassword");
    },
    login: function() {
      let self = this;

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            self.mthIncrementReturningUser();

            //console.log("logged in 150");

            self.mthSetIamthebossInStore(self.email);

            //console.log('This is store: ', self.$store);

            /*
            if(!self.$store.getters.getUserhasfilledhisassessment) 
              const filledAssessment = firebase.firestore()
              .collection("usersProfiles")
              .doc(email);
              */

            //console.log("Assessmentu nie ma");

            if (!self.$store.getters.getAvatarurl) {
              //console.log("Avatara nie ma");
              this.mthGetAvatarFromDatabase();
            }

            if (!self.$store.getters.getNickname) {
              //console.log("Nicka nie ma");
              this.mthGetNicknameFromDatabase();
            }

            if (!self.$store.getters.getUserhasfilledhisassessment) {
              //console.log("Ass nie ma");
              this.mthGetAssessmentDoneFromDatabase();
            }
          },
          function(err) {
            //alert(err.message);
            //this.set(this.data, 'validationMessage', 'eeeee')
            self.validationMessage = err.message;
            //console.log(err.message);
          }
        );
    },
    mthGetAvatarFromDatabase() {
      const avatarUrlFromDatabase = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.email)
        .get()
        .then(doc => {
          this.$store.commit(
            "setAvatarurl",
            doc.data().profilePersonalInfo.avatarUrl
          );
          //console.log("Mamy to: ", doc.data().profilePersonalInfo.avatarUrl);
        });
    },
    mthGetNicknameFromDatabase() {
      const nickFromDatabase = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.email)
        .get()
        .then(doc => {
          this.$store.commit(
            "setNickname",
            doc.data().profilePersonalInfo.nickname
          );
          //console.log("Mamy to: ", doc.data().profilePersonalInfo.nickname);
        });
    },
    mthGetAssessmentDoneFromDatabase() {
      const assessment = firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", this.email)
        .orderBy("createdAt")
        .limit(2);

      /*
      assessment.get()
      .then((querySnapshot) => {
        if (querySnapshot.exists) {
        console.log("Mamy assessment: ", doc.data().createdAt);
        }
      });
      */

      assessment.onSnapshot(querySnapshot => {
        //console.log("onsnapshot fired");

        if (querySnapshot.empty == true) {
          //console.log("EEEempty");
          this.$store.commit("setUserhasfilledhisassessment", false);
        } else {
          //console.log("Not empty");
          this.$store.commit("setUserhasfilledhisassessment", true);
        }

        /*
      querySnapshot.forEach(doc => {
        lp++;
        this.podcasts.push({
          id: doc.id,
          data: doc.data()
        });
      });*/
      });
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      //console.log('onAuthStateChanged fired!')
      if (user) {
        this.$router.replace("/");
      }
    });
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbInput
  }
};
</script>

<style>
</style>
